const audiences = [
  { icon: 'ri-seedling-line', title: 'Новые руководители', desc: 'Освоение переговорных инструментов вместе с новой управленческой ролью, чтобы увереннее вести первые сложные разговоры.' },
  { icon: 'ri-user-settings-line', title: 'Руководители среднего звена', desc: 'Работа с ежедневными сложными ситуациями внутри команды: задачи, сроки, ответственность, сотрудники.' },
  { icon: 'ri-line-chart-line', title: 'РОПы', desc: 'Переговоры с менеджерами по продажам, руководством и другими подразделениями о планах, KPI и ресурсах.' },
  { icon: 'ri-vip-crown-line', title: 'Топ-менеджеры', desc: 'Сложные переговоры, ресурсы, изменения и стратегические решения с собственниками и руководителями подразделений.' },
  { icon: 'ri-team-line', title: 'Управленческие команды', desc: 'Формирование общего подхода к сложным коммуникациям и единых правил взаимодействия внутри компании.' },
];

export default function SuitableFor() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Для кого подходит программа
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Программа адаптируется под уровень руководителей и их реальные переговорные задачи
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {audiences.map((a) => (
            <div key={a.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${a.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{a.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{a.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}